import script from "./ThirdView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdView.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdView.vue?vue&type=style&index=0&id=1df278ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df278ab"]])

export default __exports__